jQuery(function ($) {

//Slider
var $slider = $('.podcast-slider');
var $pagination = $('.podcast-slide-pagination-counter');

$slider.slick({
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: `<button class="slick-arrow slick-prev" type="button" aria-label="Previous Slide">
                    <svg class="arrow-prev" xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none" rol="img">
                        <title>Prev Arrow</title>
                        <path d="M-0.000859261 4.01L3.98914 8L4.89914 7.08L2.46914 4.66H8.11914V3.36H2.46914L4.91914 0.92L3.99914 0L-0.000859261 4.01Z" fill="#000"/>
                    </svg>
                </button>`,
    nextArrow: `<button class="slick-arrow slick-next" type="button" aria-label="Next Slide">
                    <svg class="arrow-prev" xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none" rol="img">
                        <title>Next Arrow</title>
                        <path d="M8.12 4.01L4.13 8L3.22 7.08L5.65 4.66H0V3.36H5.65L3.2 0.92L4.12 0L8.12 4.01Z" fill="#000"/>
                    </svg>
                </button>`,
});

    function updatePagination(slick) {
        var totalSlides = slick.slideCount;
        var currentPage = slick.currentSlide + 1;
        var paginationHTML = '';
            for (var i = 1; i <= totalSlides; i++) {
                paginationHTML += '<span class="podcast-slide-page-number">' + i + '</span>';
            }
        $pagination.text(currentPage + ' / ' + totalSlides);
    }

    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
        updatePagination(slick);
    });

    // Call updatePagination initially
    updatePagination($slider.slick('getSlick'));

    // Handle pagination click events
    $pagination.on('click', '.podcast-slide-page-number', function () {
        var pageNum = $(this).index();
        $slider.slick('slickGoTo', pageNum);
    });

    //Collapse
    $('.transcript-window').on('click', function (e) {
        $(this).find('#transcript').toggle();
        e.stopPropagation();
    });
});

document.querySelectorAll(".collapse-indicator-plus").forEach(function (e) {
	e.parentNode.addEventListener("click", function () {
        e.classList.toggle("chev");

	});
});